import { render, staticRenderFns } from "./x-date-filters.vue?vue&type=template&id=c1688a66&scoped=true&"
import script from "./x-date-filters.vue?vue&type=script&lang=js&"
export * from "./x-date-filters.vue?vue&type=script&lang=js&"
import style0 from "./x-date-filters.vue?vue&type=style&index=0&id=c1688a66&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1688a66",
  null
  
)

export default component.exports